import styled from "styled-components";

export const DailySettlementRevenueContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .box {
    height: 27px;
    border-radius: 15px;
    background: #7f25fb;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 14px;
    line-height: 27px;
    color: #ffffff;
    padding: 0 22.5px;
    cursor: pointer;
  }
`;

export const DailySettlementRevenueMainContentWrapper = styled.div`
  margin: 20px 0 43px;
  display: flex;
  gap: 63px;
  justify-content: space-between;

  > .chart {
    width: 400px;
  }
`;

export const DailySettlementRevenueMainBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
`;

export const DailySettlementRevenueMainBoxName = styled.div`
  font-weight: 700;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .button {
    background: #373636;
    width: max-content;
    height: 21px;
    border-radius: 15px;
    padding: 0 20px;
    font-weight: 700;
    font-size: 13px;
    line-height: 21px;
    color: #fff;
    cursor: pointer;
  }
`;

export const DailySettlementRevenueMainResult = styled.div<{
  isPurple?: boolean;
  isWhite?: boolean;
  right?: string;
}>`
  position: absolute;
  top: -2px;
  right: ${(p) => (p.right ? p.right : "16px")};

  > div {
    color: ${(p) => (p.isPurple ? "#7f25fb" : p.isWhite ? "#fff" : "#b10003")};
    font-family: Pretendard;
    font-weight: 700;
    font-size: ${(p) => (p.isWhite ? "12px" : "16px")};
    text-align: center;
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: max-content;
  }
`;
